<div class="container mt-1 production-ui" *ngIf="ProdD && ProdD.allocations">

  <!-- =========================
        RESOURCE SUMMARY
  ========================== -->
  <div class="card shadow-sm mb-4">
    <div class="card-body">

      <h5 class="mb-3 fw-bold text-primary"><i class="fa fa-solid fa-industry"></i> Factory & Robot Planning</h5>

      <!-- Factories -->
      <div class="row g-3 mb-3">

        <div class="col-md-3">
          <label class="fw-semibold text-muted">Existing factories in use</label>
          <div class="value-box readonly">{{ ProdD.F_current }}</div>
        </div>

        <div class="col-md-3">
          <label class="fw-semibold" for="factoryBuild">Factories to build this {{ RO.RoundUnit }}</label>
          <input type="number" class="form-control" [(ngModel)]="ProdD.F_investment" id="factoryBuild" name="factoryBuild" (change)="onInputChange()" />
        </div>

        <div class="col-md-3">
          <label class="fw-semibold" for="factorySell">Factories to sell this {{ RO.RoundUnit }}</label>
          <input type="number" class="form-control" [(ngModel)]="ProdD.F_sold" (change)="onInputChange()" id="factorySell" name="factorySell"/>
        </div>

      </div>

      <!-- Robots -->
      <div class="row g-3">
        <div class="col-md-3">
          <label class="fw-semibold text-muted"> Robots currently in production</label>
          <div class="value-box readonly"> {{ ProdD.R_existing }}</div>
        </div>

        <div class="col-md-4">
          <label class="fw-semibold" for="addRobot">Additional robots to purchase this year </label>
          <input type="number" class="form-control" [(ngModel)]="ProdD.R_bought" (change)="onInputChange()" id="addRobot" name="addRobot"/>
        </div>
      </div>

    </div>
  </div>

  <!-- =========================
        ALLOCATION INFO
  ========================== -->
  <div class="alert alert-info py-2 mb-4">
    <strong>Instructions:</strong>
    Allocate <strong>Labor %</strong> and <strong>Robot %</strong> for each product.
    The combined total must equal <strong>100%</strong>.
  </div>

  <!-- =========================
        PRODUCTION TABLE
  ========================== -->
  <div class="card shadow-sm">

    <div class="card-header bg-secondary text-white d-flex align-items-center">
      <h6 class="mb-0">
        <i class="bi bi-graph-up me-2"></i>
        Production Allocation
      </h6>
    </div>

    <div class="card-body p-0">

      <table class="table table-striped table-hover mb-0 align-middle text-center">
        <thead>
          <tr>
            <th>Product</th>
            <th>Labor %</th>
            <th>Robot %</th>
          </tr>
        </thead>

        <tbody>
          <tr *ngFor="let prod of ProdD.allocations">

            <!-- Product -->
            <td class="fw-semibold">
              {{ prod.productName }}
            </td>

            <!-- Labor -->
            <td>
              <input type="number" class="form-control text-center" [(ngModel)]="prod.WorkForceP"
                (change)="validatePercent(prod)" />
            </td>

            <!-- Robot -->
            <td>
              <input type="number" class="form-control text-center" [(ngModel)]="prod.AutomationP"
                (change)="validatePercent(prod)" />
            </td>

          </tr>
        </tbody>

      </table>

    </div>
  </div>

  <!-- =========================
        VALIDATION ERROR
  ========================== -->
  <div *ngIf="validationError" class="alert alert-danger mt-3 py-2">
    {{ validationError }}
  </div>

</div>